import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import FinancialStoriesApiUtils from '../utils/FinancialStoriesApiUtils';
import _ from 'lodash';
import moment from 'moment';
import FinancialStoriesConstants from '../constants/FinancialStoriesConstants';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';

let _microTransactions = [];
let _inAndOuts = [];
let _cashPoint = [];
let _tileType = '';
let _loader = true;
let _microTransactionsLoad = false;
let _cashPointLoad = false;
let _inAndOutsLoad = false;
let _showError = false;
let _error = {};
let _microTransactionsError = false;
let _inAndOutsError = false;
let _cashPointError = false;

class FinancialStoriesStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  resetStore() {
    _microTransactions = [];
    _inAndOuts = [];
    _cashPoint = [];
    _tileType = '';
    _loader = true;
    _microTransactionsLoad = false;
    _cashPointLoad = false;
    _inAndOutsLoad = false;
    _microTransactionsError = false;
    _inAndOutsError = false;
    _cashPointError = false;
  }
  getMicroTransactions(accountId, month) {
    return _.find(_microTransactions, { accountId, month });
  }
  getCashpoint(accountId, month) {
    return _.find(_cashPoint, { accountId, month });
  }
  getInsAndOuts(accountId, month) {
    return _.find(_inAndOuts, { accountId, month });
  }
  getTileLoader(tile) {
    switch (tile) {
      case 'microTransactions':
        return _microTransactionsLoad;
      case 'cashpoint':
        return _cashPointLoad;
      case 'insAndOuts':
        return _inAndOutsLoad;
      default: {
        break;
      }
    }
  }
  getLoader() {
    return _loader;
  }
  getTileType() {
    return _tileType;
  }
  getErrorFlag() {
    return _showError;
  }
  getError() {
    return _error;
  }
  getTileError(tile) {
    switch (tile) {
      case 'microTransactions':
        return _microTransactionsError;
      case 'cashpoint':
        return _cashPointError;
      case 'insAndOuts':
        return _inAndOutsError;
      default: {
        break;
      }
    }
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case FinancialStoriesConstants.SET_TILETYPE:
        _tileType = actionData.tileType;
        break;

      case FinancialStoriesConstants.FINANCIAL_STORIES_CONNECTION_REQUEST:
        _loader = true;
        _microTransactionsLoad = false;
        _cashPointLoad = false;
        _inAndOutsLoad = false;
        _microTransactionsError = false;
        _inAndOutsError = false;
        _cashPointError = false;
        _microTransactions = [];
        _inAndOuts = [];
        _cashPoint = [];
        const month = {
          month: moment().format('YYYY-MM'),
        };
        month.fromDate = 'now-6M';
        month.toDate = 'now';
        const count = 1;
        FinancialStoriesApiUtils.getFinancialStoriesConnection(
          'microTransactions',
          actionData.accountId,
          month,
          count,
          false
        );
        FinancialStoriesApiUtils.getFinancialStoriesConnection(
          'insAndOuts',
          actionData.accountId,
          month,
          count,
          false
        );
        FinancialStoriesApiUtils.getFinancialStoriesConnection(
          'cashpoint',
          actionData.accountId,
          month,
          count,
          false
        );
        break;

      case FinancialStoriesConstants.FINANCIAL_STORIES_CONNECTION_SUCCESS:
        switch (actionData.tileType) {
          case 'microTransactions':
            if (actionData.updateQuery) {
              const index = _.findIndex(_microTransactions, {
                accountId: actionData.accountId,
                month: actionData.month,
              });
              _microTransactions[index] = actionData.fsData[0];
            } else {
              _.forEach(actionData.fsData, (data) => {
                _microTransactions.push(data);
              });
              _microTransactionsLoad = true;
            }
            break;

          case 'insAndOuts':
            if (actionData.updateQuery) {
              const index = _.findIndex(_inAndOuts, {
                accountId: actionData.accountId,
                month: actionData.month,
              });
              _inAndOuts[index] = actionData.fsData[0];
            } else {
              _.forEach(actionData.fsData, (data) => {
                _inAndOuts.push(data);
              });
              _inAndOutsLoad = true;
            }
            break;

          case 'cashpoint':
            if (actionData.updateQuery) {
              const index = _.findIndex(_cashPoint, {
                accountId: actionData.accountId,
                month: actionData.month,
              });
              _cashPoint[index] = actionData.fsData[0];
            } else {
              _.forEach(actionData.fsData, (data) => {
                _cashPoint.push(data);
              });
              _cashPointLoad = true;
            }
            break;
          default: {
            break;
          }
        }
        this.emitChange();
        break;

      case FinancialStoriesConstants.MICRO_TRANSACTION_REQUEST:
        FinancialStoriesApiUtils.getFinancialStoriesConnection(
          'microTransactions',
          actionData.accountId,
          actionData.month,
          actionData.count,
          true
        );
        break;

      case FinancialStoriesConstants.CASHPOINT_REQUEST:
        FinancialStoriesApiUtils.getFinancialStoriesConnection(
          'cashpoint',
          actionData.accountId,
          actionData.month,
          actionData.count,
          true
        );
        break;

      case FinancialStoriesConstants.IN_OUT_REQUEST:
        FinancialStoriesApiUtils.getFinancialStoriesConnection(
          'insAndOuts',
          actionData.accountId,
          actionData.month,
          actionData.count,
          true
        );
        break;

      case FinancialStoriesConstants.FINANCIAL_STORIES_CONNECTION_ERROR:
        if (actionData.updateQuery) {
          _showError = true;
          _error = actionData.error;
          this.emitChange();
        } else {
          switch (actionData.type) {
            case 'microTransactions':
              _microTransactionsLoad = true;
              _microTransactionsError = true;
              break;

            case 'cashpoint':
              _cashPointLoad = true;
              _cashPointError = true;
              break;

            case 'insAndOuts':
              _inAndOutsError = true;
              _inAndOutsLoad = true;
              break;
            default: {
              break;
            }
          }
          _loader = false;
          this.emitChange();
        }
        break;

      case FinancialStoriesConstants.RESET_ERROR_FLAG:
        _showError = false;
        _error = {};
        this.emitChange();
        break;
      case AppConstants.LOGOUT_USER:
        this.resetStore();
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new FinancialStoriesStore();
